export const PROPERTY_TYPES_EXPERIMENT_NAME = 'HA_PTA_HP_PropertyTypesModule';



// WEBPACK FOOTER //
// ./src/universal/components/PropertyTypes/constants.js